import { BASE_URL } from '../../constants/baseUrl';
import axiosInstance from '../../utils/axiosInstance';

class PackageTypesService {
  /**
   * Fetch all package types
   * @returns {Promise} Axios response
   */
  fetchPackageTypes = () => {
    return axiosInstance.get(`${BASE_URL}/v1/lookups/package-types/`);
  };

  /**
   * Create a new package type
   * @param {FormData} packageTypeFormData - Form data with package type details
   * @returns {Promise} Axios response
   */
  addPackageType = (packageTypeFormData) => {
    // Let axiosInstance interceptor handle Content-Type for FormData
    return axiosInstance.post(
      `${BASE_URL}/v1/lookups/package-types/`,
      packageTypeFormData,
    );
  };

  /**
   * Update an existing package type
   * @param {number} id - Package type ID
   * @param {Object} queryParams - Query parameters for the update (packageName, packageDescription, shortCode, order)
   * @param {FormData} packageTypeFormData - FormData with package icon file (optional, multipart/form-data)
   * @returns {Promise} Axios response
   */
  updatePackageType = (id, queryParams, packageTypeFormData = null) => {
    const params = new URLSearchParams(queryParams);
    const url = `${BASE_URL}/v1/lookups/package-types/${id}?${params.toString()}`;
    const body = packageTypeFormData;
    return axiosInstance.put(url, body);
  };

  /**
   * Soft delete a package type
   * @param {number} id - Package type ID
   * @returns {Promise} Axios response
   */
  softDeletePackageType = (id) => {
    return axiosInstance.delete(
      `${BASE_URL}/v1/lookups/package-types/soft-delete/${id}`,
    );
  };

  /**
   * Permanently delete a package type
   * @param {number} id - Package type ID
   * @returns {Promise} Axios response
   */
  deletePackageType = (id) => {
    return axiosInstance.delete(`${BASE_URL}/v1/lookups/package-types/${id}`);
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new PackageTypesService();
